<fin-block-offer [offer]="offerData$ | async" class="block cf category mr-xsmall-b" />
